<template>
    <v-row>
        <v-col sm="12" cols="12" class="grayBg px-6 pl-3">
            <v-card color="white" class="pa-3 no_border" elevation="0">
                <!-- <v-row>
                    <v-col sm="12" cols="12" class="py-0">
                        <h2 class="mb-0 font_20">{{ $t('daily_cash_collection') }}</h2>
                    </v-col>
                </v-row> -->

                <v-row>
                    <v-col sm="12" cols="12">
                        <gridFullScreen>
                            <template>
                                <kendo-datasource
                                    ref="detialByItems"
                                    :type="'JSON'"
                                    :data="saleDetail"
                                    :group="group"
                                    :server-paging="false"/>
                                <kendo-grid
                                    id="detialByItems" class="grid-function"
                                    :data-source-ref="'detialByItems'"
                                    :editable="false"
                                    :groupable="true"
                                    :column-menu="true"
                                    :noRecords="true"
                                    :sortable="true"
                                    :excel-file-name="$t('daily_cash_collection')+'.xlsx'"
                                    :excel-filterable="true"
                                    :excel-all-pages="true"
                                    :toolbar="['excel']"
                                    :scrollable-virtual="true">

                                    <kendo-grid-column
                                        :title="'No'"
                                        :width="80"
                                        :template="rowNumberTmpl"
                                        :column-menu="false"
                                        :headerAttributes="{style: 'background-color: #EDF1F5;',class: 'text-products px-1' }"
                                    />
                                    <kendo-grid-column
                                        :field="'issuedDate'"
                                        :title="'Date'"
                                        :width="150"
                                        :template="'#= kendo.toString(new Date(issuedDate), `yyyy-MMM-dd`)#'"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'txnNum'"
                                        :title="'Receipt Nº'"
                                        :width="200"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'campaign'"
                                        :title="'Kind of Discount'"
                                        :width="200"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'employee'"
                                        :title="'Sale Person'"
                                        :width="200"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'itmName'"
                                        :title="'Kind of Service'"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'orderType'"
                                        :title="'Come through'"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'minnute'"
                                        :title="'Min'"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'qty'"
                                        :title="'QTY'"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'price'"
                                        :title="'Price'"
                                        :width="150"
                                        :template="'#= price.toFixed(2) #'"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'champeiamt'"
                                        :title="'Amount'"
                                        :width="150"
                                        :template="'#= champeiamt.toFixed(2) #'"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'discount'"
                                        :title="'Discount'"
                                        :width="150"
                                        :template="'#= discount.toFixed(2) #'"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'champeivat'"
                                        :title="'VAT 10%'"
                                        :width="150"
                                        :template="'#= champeivat.toFixed(2) #'"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'champeiCash'"
                                        :title="'Cash Collection'"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'champeiVisa'"
                                        :title="'Visa Card'"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />





                                    <kendo-grid-column
                                        :field="'cusType'"
                                        :hidden="true"
                                        :title="$t('customer_type')"
                                        :width="200"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'cusName'"
                                        :title="$t('customer_name')"
                                        :width="200"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    
                                    <kendo-grid-column
                                        :field="'category'"
                                        :title="$t('category')"
                                        :hidden="true"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'itmNum'"
                                        :title="$t('item_number')"
                                        :width="150"
                                        :hidden="true"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"/>
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    <kendo-grid-column
                                        :field="'champeiBank'"
                                        :title="'Bank Transfer'"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'amount'"
                                        :title="'Sale Revenue'"
                                        :width="150"
                                        :template="'#= amount.toFixed(2) #'"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'cashier'"
                                        :title="'Cashier'"
                                        :width="200"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'guesttype'"
                                        :title="'Nation'"
                                        :width="200"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'saleUnit'"
                                        :title="'Room'"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'issuedDate'"
                                        :title="$t('time')"
                                        :width="150"
                                        :template="'#= kendo.toString(new Date(issuedDate), `hh:mm tt`)#'"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                    <kendo-grid-column
                                        :field="'champeiType'"
                                        :title="$t('type')"
                                        :width="150"
                                        :attributes="{style: 'text-align: right; ', class:'tb_name_td'}"
                                        :headerAttributes="{ style: 'background-color: #EDF1F5' }"
                                    />
                                </kendo-grid>
                                <LoadingMe
                                    :isLoading="showLoading"
                                    :fullPage="false"
                                    type="loading"
                                    :myLoading="true"
                                    :color="loadingColorAlert"
                                    :alertText="loadingTextAlert"/>
                            </template>
                        </gridFullScreen>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import JSZip from "jszip";
window.JSZip = JSZip;
export default {
    name: 'CashCollection',
    props: {saleDetail: {}},
    components: {
        LoadingMe: () => import(`@/components/Loading`),
        gridFullScreen: () => import("@/components/gridFullScreen"),
    },
    data: () => ({
        showLoading: false,
        loadingAlert: false,
        loadingColorAlert: '',
        loadingTextAlert: '',
        startDate: new Date().toISOString().substring(0, 10),
        endDate: new Date().toISOString().substring(0, 10),
        group: {field: 'txnNum'},
    }),
    computed: {},
    methods: {
        rowNumberTmpl(dataItem) {
            let ds = this.$refs.detialByItems.kendoWidget(),
                index = ds.indexOf(dataItem);
            return index + 1;
        },
    },
};
</script>
<style scoped>
.acc_group header {
    height: 10px !important;
}

table.acc_group tr td {
    border-bottom: 1px solid #ccc;
    padding: 8px;
    vertical-align: middle;
}

table.acc_group tr td:first-child {
    font-weight: 700;
}

table.acc_group tr td:last-child {
    text-align: center;
}

.v-card__actions .v-btn.v-btn {
    padding: 0 16px;
}

.exchange-table.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-family: 'Niradei-Bold', serif;
    color: #000 !important;
    border-top: 1px solid #000 !important;
    border-bottom: 1px solid #000 !important;
    font-size: 15px !important;
}

.exchange-table.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > td {
    color: #000 !important;
    padding: 5px !important;
}

.exchange-table.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:last-child td {
    border-bottom: 1px solid #000 !important;
}

.function_footer {
    padding: 15px;
    display: inline-block;
}

p {
    color: rgba(0, 0, 0, 0.87);
}

.actionBtn {
    height: 47.2px !important;
}

.text_tip {
    font-size: 9px;
    line-height: 10px;
}

@media (max-width: 576px) {

}
</style>
